"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedDependencies = void 0;
/**
 * The list of shared dependencies.
 */
exports.sharedDependencies = {
    'single-spa': {
        entrypoint: 'single-spa.min.js',
        entrypointDev: 'single-spa.dev.js',
        distFolder: 'lib/es2015/system',
    },
    'single-spa-vue': {
        entrypoint: 'single-spa-vue.js',
        distFolder: 'dist/system',
    },
    vue: {
        entrypoint: 'system/vue.prod.js',
        entrypointDev: 'system/vue.dev.js',
        distFolder: 'dist',
        forceVersion: true,
        rollupConfig: {
            sourceInput: 'dist/vue.esm-browser.prod.js',
            sourceInputDev: 'dist/vue.esm-browser.js',
        },
    },
    'vue-router': {
        entrypoint: 'system/vue-router.prod.js',
        distFolder: 'dist',
        rollupConfig: {
            sourceInput: 'dist/vue-router.esm-browser.js',
            inputOptions: {
                external: ['vue'],
            },
        },
    },
    '@iu/oxy': {
        entrypoint: 'oxy.system.js',
        distFolder: 'dist',
        legacyIncompatible: true,
    },
};
